const nav = document.querySelector('nav.top.navbar');
const navbarNav = (nav) ? nav.querySelector('#navbarNav') : null;
const navbarToggler = (nav) ? nav.querySelector('.navbar-toggler') : null;
const navbarLogoContainer = (nav) ? nav.querySelector('.jsNavbarBrand') : null;
const navbarLogo = (navbarLogoContainer) ? navbarLogoContainer?.querySelector('img') : null;
const position = (nav) ? window.getComputedStyle(nav, null).position : null;
let timeout;

if(position === "absolute" || position === "fixed" || position === "sticky") {
    bodyMarginTop(nav);
    window.addEventListener('resize', () => {
        //Gør at padding funktionen først kører når eventuelle css animationer er færdige
        if(timeout) window.cancelAnimationFrame(timeout);
        timeout = window.requestAnimationFrame(() => bodyMarginTop(nav));
    }, false);
}

if(nav) {
    const navItems = document.querySelectorAll('.nav-item:not(.dropdown)');
    const bsCollapse = new bootstrap.Collapse(navbarNav, {toggle: false});
    navItems.forEach(link => link.addEventListener('click', () => bsCollapse.hide()));
    
    navbarToggler.addEventListener('click', () => {
        if(navbarToggler.classList.contains('collapsed')) {
            nav.style.overflowY = 'visible';
        } else {
            nav.style.overflowY = 'scroll';
        }
    });
}

if(nav && nav.classList.contains('logoBreakFrame')) {
    navbarToggler.addEventListener('click', () => {
        if(navbarToggler.classList.contains('collapsed')) {
            navbarLogo.classList.remove("h-100");
            navbarLogo.classList.add("w-100");
            navbarLogo.style.maxWidth = '100%';
            navbarLogoContainer.style.height = 'auto';
            navbarLogoContainer.style.display = 'inline';
        } else {
            navbarLogo.classList.remove("w-100");
            navbarLogo.classList.add("h-100");
            navbarLogo.style.maxWidth = 'none';
            navbarLogoContainer.style.height = '50px';
            navbarLogoContainer.style.display = 'block';
        }
    });
}

function bodyMarginTop(nav) {
    document.body.style.marginTop = `${nav.offsetHeight}px`;
}
